import { render, staticRenderFns } from "./CreateTaskModal.vue?vue&type=template&id=4a64fbbe&scoped=true&"
import script from "./CreateTaskModal.vue?vue&type=script&lang=js&"
export * from "./CreateTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTaskModal.vue?vue&type=style&index=0&id=4a64fbbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64fbbe",
  null
  
)

export default component.exports